// src/components/Navbar.js

import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const [shrink, setShrink] = useState(false);
  const location = useLocation();

  // If home page => scroll logic, else always shrink
  useEffect(() => {
    if (location.pathname === "/") {
      const handleScroll = () => {
        setShrink(window.scrollY > 100);
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    } else {
      setShrink(true);
    }
  }, [location]);

  // If you want to hide the logo on mobile, do it here or in CSS
  const isMobile = window.innerWidth < 768;

  return (
    <header className={`navbar ${shrink ? "shrink" : ""}`}>
      <div className="navbar-inner">
        <div className="nav-logo">
          {shrink && !isMobile && (
            <img
              src="/images/clipperkings.png"
              alt="Clipper Kings Nav Logo"
              style={{ height: "50px" }}
            />
          )}
        </div>
        <nav className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/contact">Contact Us</Link>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
